import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, first } from 'rxjs';
import { TEXTS_VARIABLE } from '../../constants/constants-texts';
import { ContactscreenCoreService } from '../../../@root-redux/contactscreen/services/contactscreen.service';

@Injectable({
  providedIn: 'root',
})
export class NavigatorService {
  private source: string | undefined;
  private subjectShowArror = new BehaviorSubject(false);
  public showArrow$ = this.subjectShowArror.asObservable();
  private subjectshowChatButton = new BehaviorSubject(true);
  public showChatButton$ = this.subjectshowChatButton.asObservable();
  public isQuestion = new BehaviorSubject<boolean>(false);
  public isQuestion$ = this.isQuestion.asObservable();
  public isChat = new BehaviorSubject<boolean>(false);
  public isChat$ = this.isChat.asObservable();
  private initialUrl!: string;
  private deeplink!: string;
  private searchDisabled!: string;
  private isFromContextHelp = false;
  historyLength: number = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private contactscreenCoreService: ContactscreenCoreService,
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any): void => {
        const urlSegments = event.urlAfterRedirects
          .split('/')
          .filter((segment: string) => segment);
        this.subjectShowArror.next(!!urlSegments.length);
        const cleanedUrl = event.url.split('?')[0];
        const showChatButton = cleanedUrl === '/' && !this.isFromContextHelp;
        this.subjectshowChatButton.next(showChatButton);
        this.historyLength++;
      });
    this.route.queryParams.pipe(first()).subscribe((params: any) => {
      this.source = params.source;
      this.deeplink = params.deeplink;
      this.initialUrl = params.deeplink ? window.location.href : '';
      this.searchDisabled = params.searchDisabled;
      this.setUserData(params);
    });
  }

  get isMobile(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isMobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|pocket/i;

    return isMobileRegex.test(userAgent);
  }

  get isApp(): boolean {
    return !!this.source;
  }
  get isSearchDisabled(): boolean {
    return !!this.searchDisabled;
  }

  getInitialUrl(): string {
    return this.initialUrl;
  }

  getDeeplink(): string {
    return this.deeplink;
  }

  setTitle(text: string): void {
    this.titleService.setTitle(text);
  }

  setDynamicTitle(text: string): void {
    this.titleService.setTitle(TEXTS_VARIABLE.dinamicTitle(text));
  }

  setSearchTitle(text: string): void {
    this.titleService.setTitle(TEXTS_VARIABLE.searchTitle(text));
  }

  private setUserData(queryParams: any): void {
    queryParams['customerId'] &&
      this.contactscreenCoreService.setCustomerId(queryParams['customerId']);

    queryParams['globalId'] &&
      this.contactscreenCoreService.setGlobalId(queryParams['globalId']);

    queryParams['birthDate'] &&
      this.contactscreenCoreService.setCustomerBirthDate(
        queryParams['birthDate'],
      );

    this.contactscreenCoreService.setCdaJourney(
      queryParams['tripIdentifier'] || 'Centro de ayuda',
    );

    this.isFromContextHelp = !!queryParams['tripIdentifier'];

    this.analyticsInit(window, queryParams['globalId']);
  }

  private analyticsInit(window: any, userId: string): void {
    sessionStorage.setItem('p-userIdParam', userId);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'authentication',
      userId,
    });
  }
}
